import Vue from 'vue'
import Storage from 'vue-ls'

import VueClipboard from 'vue-clipboard2' // 复制粘贴

import injectInstanceProperty from '@/config/inject'
import injectComponents from '@/components/inject'
import { mixinCommon } from '@/services/mixins'

import router from '@/router'
import store from '@/store'
import App from '@/App'

import AmazonHref from '@/directive/amazon-href'
import autoBlur from '@/directive/autoBlur'

import * as filters from './filters' // global filters

import { Plugin } from 'vue-fragment'
// import { Share } from '@icon-park/vue'
import { PatchElMessagePlugin } from '@/plugins/patch-el-message-plugin'
import initBurialOoint, { sendRecordBuriedPoint } from '@/utils/hawk'

import i18n from '@/i18n'
import '@/plugins/dialog-component'
import './icons' // icon

import './assets/custom-font/index.scss' // 引入自定义字体
import '@/styles/tailwindcss.scss'
import '../static/icon-ali/iconfont.css'
import '../static/icon-ali/iconfont.js'
import '@/styles/transition.scss'
import '@/styles/element-variables.scss'
import '@/styles/element-ui.scss'
import '@/styles/sidebar.scss'
import '@/styles/button.scss'
import '@/styles/vxe-table.scss'
import '@/styles/icon.scss'
import '@/styles/scb-patch.scss' // 深圳团队样式补丁包
import '@/styles/index.scss' // global css
import '@/styles/hc-style.scss'

import 'nprogress/nprogress.css'

// import Paragraph from 'vue-paragraph'
// 直接粘贴源代码到 @/components/HcTextParagraph
// Vue.use(Paragraph)
Vue.prototype.$sendRecordBuriedPoint = sendRecordBuriedPoint
// 初始化鹰眼
initBurialOoint()

Vue.use(VueClipboard)
Vue.use(injectInstanceProperty)
Vue.use(injectComponents)

Vue.mixin(mixinCommon)

Vue.use(Plugin)
// Vue.use(Share)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.directive('outFocus', {
  bind: function(el) {
    if (el) {
      el.addEventListener('click', () => {
        const target = el
        target.blur()
      }, true)
    }
  }
})
Vue.directive('amazon-href', AmazonHref)
Vue.directive('auto-blur', autoBlur)
// 本地存储
Vue.use(Storage, {
  namespace: 'wangdian__store__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
})

// 拦截 this.$message 需要在element注册之后注册
Vue.use(PatchElMessagePlugin)

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App),
  i18n,
})

// pageTag init
store.dispatch('pageTag/initTagList')

// mount
app.$mount('#app')

const h = app.$createElement

// 本应用对应的h, jsx里面会使用到
// 该 h 会包含全局注册的组件
export const getVueH = () => h
export const getApp = () => app
export default app
